import { Action } from '../action';
import { AuthType } from '../Auth/action';
import { PropertiesState } from './state';
import { PropertiesType } from './action';

export const initialPropertiesState: PropertiesState = {
    properties: [],
};

export const propertiesReducer = (state: PropertiesState | undefined, action: Action): PropertiesState => {
    state = state ?? initialPropertiesState;

    switch (action.type) {
        case PropertiesType.PropertiesLoaded:
            return { ...state, properties: action.properties };
        case AuthType.TokenExpired:
            return initialPropertiesState;
        default:
            return state;
    }
};
